import { app } from '../../../../../bootstrap/core';
import { contractPartnerCancellationComponent } from './contractPartnerCancellation.component';

app.component(
  'contractPartnerCancellation',
  contractPartnerCancellationComponent,
);
